import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoKk: CultureInfo = {
  name: 'kk',
  displayName: 'Kazakh',
  iso3LanguageCode: 'kaz',
  iso2LanguageCode: 'kk',
  ietfLanguageTag: 'kk',
  parent: null
};
